import {gql} from 'apollo-angular';

export const GET_SCHOOL_CLASS_GRADES = gql`
  query GetSchoolClassGrades {
    schoolClassGrades {
      id, name
    }
  }
`;
